var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IntegrationPlatformType } from 'app/integrations/models/integration.model';
import { EMPTY } from 'rxjs';
import { environment } from 'environments/environment';
var PlatformSpecifics = /** @class */ (function () {
    function PlatformSpecifics() {
        this.howToLink = environment.DEFAULT_HOW_TO_LINK;
    }
    PlatformSpecifics.prototype.handleUninstall = function (platform) {
        return EMPTY;
    };
    return PlatformSpecifics;
}());
export { PlatformSpecifics };
var PipeDriveSpecifics = /** @class */ (function (_super) {
    __extends(PipeDriveSpecifics, _super);
    function PipeDriveSpecifics(integrationsService) {
        var _this = _super.call(this) || this;
        _this.integrationsService = integrationsService;
        _this.allowsImport = true;
        _this.allowsUninstall = true;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.shouldDisplayAccountName = true;
        _this.installationUrl = environment.PIPEDRIVE_INTEGRATION_URL;
        _this.howToLink = environment.PIPEDRIVE_HOW_TO_LINK;
        return _this;
    }
    PipeDriveSpecifics.prototype.handleUninstall = function (platform) {
        return this.integrationsService.deleteIntegration(IntegrationPlatformType.PIPEDRIVE);
    };
    return PipeDriveSpecifics;
}(PlatformSpecifics));
export { PipeDriveSpecifics };
var ShopifySpecifics = /** @class */ (function (_super) {
    __extends(ShopifySpecifics, _super);
    function ShopifySpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = true;
        _this.allowsUninstall = false;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.shouldDisplayAccountName = true;
        _this.installationUrl = environment.SHOPIFY_INTEGRATION_URL;
        _this.howToLink = environment.SHOPIFY_HOW_TO_LINK;
        return _this;
    }
    return ShopifySpecifics;
}(PlatformSpecifics));
export { ShopifySpecifics };
var LiveChatSpecifics = /** @class */ (function (_super) {
    __extends(LiveChatSpecifics, _super);
    function LiveChatSpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = false;
        _this.allowsUninstall = false;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.shouldDisplayAccountName = true;
        _this.installationUrl = environment.LIVECHAT_INTEGRATION_URL;
        _this.howToLink = environment.LIVECHAT_HOW_TO_LINK;
        return _this;
    }
    return LiveChatSpecifics;
}(PlatformSpecifics));
export { LiveChatSpecifics };
var MagentoSpecifics = /** @class */ (function (_super) {
    __extends(MagentoSpecifics, _super);
    function MagentoSpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = false;
        _this.allowsUninstall = false;
        _this.allowAutoResync = false;
        _this.useApiKey = true;
        _this.shouldDisplayAccountName = true;
        _this.installationUrl = environment.MAGENTO_INTEGRATION_URL;
        _this.howToLink = environment.MAGENTO_HOW_TO_LINK;
        return _this;
    }
    return MagentoSpecifics;
}(PlatformSpecifics));
export { MagentoSpecifics };
var ShoperSpecifics = /** @class */ (function (_super) {
    __extends(ShoperSpecifics, _super);
    function ShoperSpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = true;
        _this.allowsUninstall = true;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.shouldDisplayAccountName = true;
        _this.installationUrl = environment.SHOPER_INTEGRATION_URL;
        _this.howToLink = environment.SHOPER_HOW_TO_LINK;
        return _this;
    }
    ShoperSpecifics.prototype.handleUninstall = function (platform) {
        window.location.href = environment.SHOPER_INTEGRATION_URL;
        return EMPTY;
    };
    return ShoperSpecifics;
}(PlatformSpecifics));
export { ShoperSpecifics };
var ZendeskSpecifics = /** @class */ (function (_super) {
    __extends(ZendeskSpecifics, _super);
    function ZendeskSpecifics(integrationsService) {
        var _this = _super.call(this) || this;
        _this.integrationsService = integrationsService;
        _this.allowsImport = true;
        _this.allowsUninstall = true;
        _this.useApiKey = false;
        _this.installationUrl = environment.ZENDESK_INTEGRATION_URL;
        _this.allowAutoResync = true;
        _this.shouldDisplayAccountName = true;
        _this.howToLink = environment.ZENDESK_HOW_TO_LINK;
        return _this;
    }
    ZendeskSpecifics.prototype.handleUninstall = function (platform) {
        return this.integrationsService.deleteIntegration(IntegrationPlatformType.ZENDESK);
    };
    return ZendeskSpecifics;
}(PlatformSpecifics));
export { ZendeskSpecifics };
var HubspotSpecifics = /** @class */ (function (_super) {
    __extends(HubspotSpecifics, _super);
    function HubspotSpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = true;
        _this.allowsUninstall = false;
        _this.allowAutoResync = true;
        _this.useApiKey = false;
        _this.shouldDisplayAccountName = true;
        _this.installationUrl = environment.BASE_BACKEND_URL + environment.HUBSPOT_INTEGRATION_PATH;
        _this.howToLink = environment.HUBSPOT_HOW_TO_LINK;
        return _this;
    }
    return HubspotSpecifics;
}(PlatformSpecifics));
export { HubspotSpecifics };
var ZapierSpecifics = /** @class */ (function (_super) {
    __extends(ZapierSpecifics, _super);
    function ZapierSpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = false;
        _this.allowsUninstall = false;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.shouldDisplayAccountName = false;
        _this.installationUrl = environment.ZAPIER_INTEGRATION_URL;
        _this.customConnectIcon = 'assets/img/channels/arrow-connect.svg';
        return _this;
    }
    return ZapierSpecifics;
}(PlatformSpecifics));
export { ZapierSpecifics };
var TwoWaySpecifics = /** @class */ (function (_super) {
    __extends(TwoWaySpecifics, _super);
    function TwoWaySpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = false;
        _this.allowsUninstall = false;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.requiresSupportContact = true;
        _this.shouldDisplayAccountName = false;
        _this.installationUrl = environment.TWO_WAY_INTEGRATION_URL;
        _this.externalPanelUrl = environment.TWO_WAY_INTEGRATION_URL;
        return _this;
    }
    return TwoWaySpecifics;
}(PlatformSpecifics));
export { TwoWaySpecifics };
var IntegromatSpecifics = /** @class */ (function (_super) {
    __extends(IntegromatSpecifics, _super);
    function IntegromatSpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = false;
        _this.allowsUninstall = false;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.shouldDisplayAccountName = false;
        _this.installationUrl = environment.INTEGROMAT_INTEGRATION_URL;
        return _this;
    }
    return IntegromatSpecifics;
}(PlatformSpecifics));
export { IntegromatSpecifics };
var WebCallSpecifics = /** @class */ (function (_super) {
    __extends(WebCallSpecifics, _super);
    function WebCallSpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = false;
        _this.allowsUninstall = false;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.requiresSupportContact = true;
        _this.shouldDisplayAccountName = false;
        _this.isInstalledAutomatically = false;
        _this.installationUrl = environment.TWO_WAY_INTEGRATION_URL;
        return _this;
    }
    return WebCallSpecifics;
}(PlatformSpecifics));
export { WebCallSpecifics };
var ClientifySpecifics = /** @class */ (function (_super) {
    __extends(ClientifySpecifics, _super);
    function ClientifySpecifics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowsImport = false;
        _this.allowsUninstall = false;
        _this.allowAutoResync = false;
        _this.useApiKey = false;
        _this.requiresSupportContact = false;
        _this.shouldDisplayAccountName = false;
        _this.isInstalledAutomatically = true;
        _this.installationUrl = environment.CLIENTIFY_INTEGRATION_URL;
        _this.customConnectIcon = 'assets/img/channels/arrow-connect.svg';
        _this.howToLink = environment.CLIENTIFY_HOW_TO_LINK;
        return _this;
    }
    return ClientifySpecifics;
}(PlatformSpecifics));
export { ClientifySpecifics };
